export default async (_, inject) => {
    inject("dataLayer", {
        overwrite(data) {
            const sessionDataStr = sessionStorage?.getItem('dataLayer') || '[]';
            let sessionData = JSON.parse(sessionDataStr);
            const findIndex = window.dataLayer.findIndex((e) => e.event === data.event);
            if (0 <= findIndex) {
                window.dataLayer.splice(findIndex, 1);
                window.dataLayer.push(data);
                sessionData = sessionData.filter((e)=> e.event !== data.event);
                sessionData.push(data);
            } else {
                window.dataLayer.push({...data});
                sessionData.push({...data});
            }
            sessionStorage?.setItem('dataLayer', JSON.stringify(sessionData));
        }
    });
};
